import { ProductTypeView, SearchProductTypesParameters } from '@api-proxies';
import { ProductTypeService } from '@http/clients/product-type.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { IComponentEditorEntity } from '../../entity-interfaces/editor-entity.interface';

export abstract class ProductTypeEntity<TEntityDestination>
    implements IComponentEditorEntity<ProductTypeView, TEntityDestination>
{
    constructor(private readonly productTypeService: ProductTypeService) {}

    abstract toDestination(entity: ProductTypeView): TEntityDestination;

    abstract toSource(entity: TEntityDestination): ProductTypeView;

    async getSource(entityType: EntityTypes, filterText = '', isActive = true): Promise<ProductTypeView[]> {
        const productTypes = await this.productTypeService.search({
            filterText,
            isActive
        } as SearchProductTypesParameters);
        return productTypes ?? [];
    }
}
